import "../../styles.css";

const RolesSelect = (props) => {
    const {
        role,
        rolesCount,
        setRole
    } = props;

    return (
        <div>
            <button
                onClick={() => setRole('')}
                className={`bg-white border-0 user-role-btn ${!role ? 'active-role' : ''}`}
            >
                <span>All</span> ({rolesCount.users})
            </button>
            <button
                onClick={() => setRole('ADMIN')}
                className={`bg-white border-0 user-role-btn ${role == 'ADMIN' ? 'active-role' : ''}`}
            >
                <span>Administrator</span> ({rolesCount.admins})
            </button>
            <button
                onClick={() => setRole('SU')}
                className={`bg-white border-0 user-role-btn ${role == 'SU' ? 'active-role' : ''}`}
            >
                <span>Subscriber</span> ({rolesCount.subscribers})
            </button>
            <button
                onClick={() => setRole('PU')}
                className={`bg-white border-0 user-role-btn ${role == 'PU' ? 'active-role' : ''}`}
            >
                <span>PU</span> ({rolesCount.pus})
            </button>
        </div>
    );
};

export default RolesSelect;
